import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';

@Injectable({
  providedIn: 'root'
})
export class DownloadFileService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) { }

  downloadFile(form_name: string, caseId: string): Observable<Blob> {
    const url = environment.apiBaseUrl + endpoints.downloadFile.replace(':form_name', form_name).replace(':caseId', caseId);
    return this.http.get(url, {
      responseType: 'blob'
    }).pipe(
      catchError(this.errorService.handleError)
    );
  }
}